import { useQuery } from "@tanstack/react-query";
import { useGeotabClient } from "@/components/GeotabClientContext";
import { MaintenanceWorkOrder } from "@/models/MaintenanceWorkOrder";

export function useMaintenanceWorkOrder() {
  const { geotabClient, activeSessionId } = useGeotabClient();

  return useQuery<MaintenanceWorkOrder[]>({
    queryKey: ["maintenanceWorkOrder", activeSessionId],

    queryFn: ({ signal }) => {
      return geotabClient.call(
        "Get",
        {
          typeName: "MaintenanceWorkOrder",
          search: {
            deviceSearch: {
              fromDate: new Date(),
            },
          },
        },
        signal,
        // API returns data already populated (User, Device, etc. already filled)
      ) as unknown as Promise<MaintenanceWorkOrder[]>;
    },

    refetchInterval: 30000,
  });
}
